import {
  UserSubaccountRole,
  UserTenantRole,
} from "~frontend/__generated__/graphql";
import { UserSubaccountMembership } from "~frontend/providers/LoggedInUserProvider";

const ROLE_HIERARCHY: (UserSubaccountRole | UserTenantRole)[] = [
  UserSubaccountRole.Texter,
  UserSubaccountRole.Supervolunteer,
  UserSubaccountRole.Admin,
  UserTenantRole.Owner,
  UserTenantRole.Staff,
];

export function userIsSubaccountAdminOrHigher(
  userSubaccountMembership: UserSubaccountMembership
): boolean {
  return (
    ROLE_HIERARCHY.indexOf(userSubaccountMembership.role) >=
    ROLE_HIERARCHY.indexOf(UserSubaccountRole.Admin)
  );
}

export function userIsSubaccountSupervolunteerOrHigher(
  userSubaccountMembership: UserSubaccountMembership
): boolean {
  return (
    ROLE_HIERARCHY.indexOf(userSubaccountMembership.role) >=
    ROLE_HIERARCHY.indexOf(UserSubaccountRole.Supervolunteer)
  );
}

export function userIsEqualOrLower(
  role1: UserSubaccountRole | UserTenantRole,
  role2: UserSubaccountRole | UserTenantRole
): boolean {
  return ROLE_HIERARCHY.indexOf(role1) >= ROLE_HIERARCHY.indexOf(role2);
}

export function rolesEqualToOrLower(
  userSubaccountMembership: UserSubaccountMembership
): (UserSubaccountRole | UserTenantRole)[] {
  return ROLE_HIERARCHY.slice(
    0,
    ROLE_HIERARCHY.indexOf(userSubaccountMembership.role) + 1
  );
}
